module.exports = "<div class=\"tickettypes\">tickettypes</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/tickettypes/tickettypes.html
// module id = 1442
// module chunks = 0